import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gamepad2, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative border-t border-white/10 bg-black/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg gaming-gradient flex items-center justify-center">
                <Gamepad2 className="w-6 h-6 text-white" />
              </div>
              <span className="font-display text-xl font-bold gaming-gradient-text">
                {t('brand')}
              </span>
            </div>
            <p className="text-white/50 text-sm mb-6">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.support.title')}</h4>
            <div className="space-y-3">
              <a href="tel:+40318262751" className="flex items-center gap-2 text-white/50 hover:text-white transition-colors text-sm">
                <Phone className="w-4 h-4" />
                +40318262751
              </a>
              <a href="mailto:ro@dawnofbattles.com" className="flex items-center gap-2 text-white/50 hover:text-white transition-colors text-sm">
                <Mail className="w-4 h-4" />
                ro@dawnofbattles.com
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4">Links</h4>
            <div className="space-y-2">
              <a href="/terms.html" className="block text-white/50 hover:text-white transition-colors text-sm">
                {t('footer.links.terms')}
              </a>
              <a href="/privacy.html" className="block text-white/50 hover:text-white transition-colors text-sm">
                {t('footer.links.cookies')}
              </a>
              <a href="#contact" className="block text-white/50 hover:text-white transition-colors text-sm">
                {t('footer.links.contact')}
              </a>
            </div>
          </div>
        </div>

        {/* Service Info */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-center text-white/60 text-sm mb-2">
            <span className="font-semibold">{t('footer.service.name')}</span> - {t('footer.service.description')}
          </p>
          <p className="text-center text-white/40 text-sm">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
